import { render, staticRenderFns } from "./VObject.vue?vue&type=template&id=64aa88f2&"
import script from "./VObject.vue?vue&type=script&lang=js&"
export * from "./VObject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports